import { Routes, Route, Navigate } from "react-router";
import JourneysPage from "@/pages/communications/journeys/index";
import JourneyBuilderPage from "@/pages/communications/journeys/builder";
import EmailBuilderPage from "./email-builder";
import ContentEditorPage from "./content-editor";
import DmFlowBuilderPage from "./dm-flows";
import DmBroadcastPage from "./dm-broadcasts";
import SendTimePage from "./send-time";
import DynamicBlocksPage from "./dynamic-blocks";
import { MountedSurfaceGate } from "@/components/truth/mounted-surface-gate";

function GrowthToolsGate() {
  return (
    <MountedSurfaceGate
      title="Growth Tools — Coming Soon"
      description="QR codes, comment triggers, and link-based entry points for DM flows are planned but not yet built."
      evidence="No backend API exists for growth tool CRUD. This gate prevents exposing a fake surface."
      liveLinks={[
        {
          label: "DM Flow Builder",
          to: "/communications/dm-flows",
          description: "Build the flows that growth tools will feed into.",
        },
        {
          label: "Broadcasts",
          to: "/communications/dm-broadcasts",
          description: "Send messages to audiences directly while growth tools are in development.",
        },
      ]}
    />
  );
}

/**
 * Communications module — journeys, email builder, DM flows, broadcasts,
 * send-time intelligence, and content editor.
 *
 * Deliverability redirects to /email/deliverability where the real
 * backend-connected dashboard lives.
 */
export default function CommunicationsPage() {
  return (
    <Routes>
      <Route index element={<Navigate to="journeys" replace />} />
      <Route path="journeys" element={<JourneysPage />} />
      <Route path="journeys/builder" element={<JourneyBuilderPage />} />
      <Route path="email-builder" element={<EmailBuilderPage />} />
      <Route path="content-editor" element={<ContentEditorPage />} />
      <Route path="deliverability" element={<Navigate to="/email/deliverability" replace />} />
      <Route path="send-time" element={<SendTimePage />} />
      <Route path="dynamic-blocks" element={<DynamicBlocksPage />} />
      <Route path="dm-flows" element={<DmFlowBuilderPage />} />
      <Route path="dm-broadcasts" element={<DmBroadcastPage />} />
      <Route path="dm-flows/growth-tools" element={<GrowthToolsGate />} />
    </Routes>
  );
}
